/**
 * @generated SignedSource<<bf02cbb09481aed100d060e431466f2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type notifyFairUseLimitReachedMutation$variables = {
  serviceName: string;
};
export type notifyFairUseLimitReachedMutation$data = {
  readonly notifyFairUseLimitReached: boolean;
};
export type notifyFairUseLimitReachedMutation = {
  response: notifyFairUseLimitReachedMutation$data;
  variables: notifyFairUseLimitReachedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "serviceName",
        "variableName": "serviceName"
      }
    ],
    "kind": "ScalarField",
    "name": "notifyFairUseLimitReached",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "notifyFairUseLimitReachedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "notifyFairUseLimitReachedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ddf5bd2a6afa3c3087f843cfc79c0826",
    "id": null,
    "metadata": {},
    "name": "notifyFairUseLimitReachedMutation",
    "operationKind": "mutation",
    "text": "mutation notifyFairUseLimitReachedMutation(\n  $serviceName: String!\n) {\n  notifyFairUseLimitReached(serviceName: $serviceName)\n}\n"
  }
};
})();

(node as any).hash = "8df882047585282cc64b5c35de03d538";

export default node;
